import { render, staticRenderFns } from "./TheWeekPagination.vue?vue&type=template&id=4a8ca716&scoped=true&"
import script from "./TheWeekPagination.vue?vue&type=script&lang=js&"
export * from "./TheWeekPagination.vue?vue&type=script&lang=js&"
import style0 from "./TheWeekPagination.vue?vue&type=style&index=0&id=4a8ca716&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8ca716",
  null
  
)

export default component.exports